import { useEffect, useState } from "react";
import {
  Button,
  Form,
} from "react-bootstrap";
import ReactSelect from "react-select";
import { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  ChangedRoleAccessScreenAction,
} from "../../../Redux/Actions/AdminActions";
// import { getAdvertiser } from "../../Redux/Actions/CCreativeUploadActions";
import { IReduxState } from "../../../utils/types";
import { Roles } from "../../../utils/enums";
import { GetRoleListAction } from "../../../Redux/Actions/RoleAction";

const Option = (props: any) => {
    return (
      <div>
        <components.Option {...props}>
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

const RolesTab = () => {
    const dispatch = useDispatch();
    const [optionSelected, setOptionSelected] = useState<any>({});
    const [rolesList, setRolesList] = useState<Array<any>>([]);
    const rolesState = useSelector((state: IReduxState) => state.Roles);
    const [roleAccessPage, setRoleAccessPage] = useState<any>([]);
    const handleChangeRoleAccess = (selected: any) => {
        setOptionSelected(selected);
      };
    useEffect(() => {
        if (rolesState.roles) {
          const temp: any = [];
          rolesState.roles.map((obj: any) => {
            return temp.push({
              ...obj,
              value: obj.role_name,
              label: obj.role_name,
            });
          });
          setRolesList(temp);
        }
      }, [rolesState.roles]);
      useEffect(() => {
        if (Object.keys(optionSelected).length !== 0) {
          setRoleAccessPage(optionSelected.access_screen);
        }
      }, [optionSelected]);
    const handleSaveRoleAccess = () => {
        let currentRole = rolesList.find((x) => x._id === optionSelected._id);
        if (
          currentRole &&
          currentRole.access_screen?.toString() !== roleAccessPage.toString()
        ) {
          dispatch(
            ChangedRoleAccessScreenAction({
              id: optionSelected._id,
              access_screen: roleAccessPage,
            })
          );
          dispatch(GetRoleListAction());
        }
    };

    const screenRoles = [
      { screen: "Admin", permission: [Roles.ADMIN] },
      { screen: "Tag-Generator", permission: [Roles.ADMIN, Roles.TAGGER] },
      { screen: "Image-Tester", permission: [Roles.ADMIN, Roles.SEGMENT] },
      { screen: "Targeting-Config", permission: [Roles.ADMIN, Roles.SEGMENT] },
      { screen: "OP-Reporting", permission: [Roles.ADMIN, Roles.OPREPORTING] },
      { screen: "Campaigns", permission: [Roles.ADMIN, Roles.CAMP] },
      { screen: "CTargeting", permission: [Roles.ADMIN, Roles.CTARGET] },
      {
        screen: "PROD-Filtering",
        permission: [Roles.ADMIN, Roles.PROD_FILTERING],
      },
      {
        screen: "DEMO-Filtering",
        permission: [Roles.ADMIN, Roles.DEMO_FILTERING],
      },
      { screen: "Event-Logger", permission: [Roles.ADMIN, Roles.CLOGGER] },
      { screen: "Ads-Impressions", permission: [Roles.ADMIN, Roles.AIMP] },
      {
        screen: "OP-Creative-Upload",
        permission: [Roles.ADMIN, Roles.OP_CREATIVE_UPLOAD],
      },
      // { screen: "GLU", permission: [Roles.ADMIN, Roles.GLU] },
      { screen: "Ads-Dashboard", permission: [Roles.ADMIN, Roles.ADSD] },
      { screen: "Bid-Requests", permission: [Roles.ADMIN, Roles.BID_REQUESTS] },
      { screen: "User-Management", permission: [Roles.ADMIN, Roles.SUPER_USER] },
      { screen: "Creative-Upload", permission: [Roles.ADMIN, Roles.CREATIVE_UPLOAD] }
    ];

    const handleChaneRoleAccessPage = (e: any, screenName: any) => {
        const tempArr = [...roleAccessPage];
        if (e.target.checked) {
          tempArr.push(screenName);
        } else if (!e.target.checked) {
          const find = tempArr.findIndex((id: any) => id === screenName);
          tempArr.splice(find, 1);
        }
        setRoleAccessPage([...tempArr]);
      };

    return (
        <>
                <div className="users-access-section">
                  <div className="select-domins">
                    <p>Choose Role</p>
                    <div className="input-box">
                      <ReactSelect
                        className="input-box-item"
                        name="users"
                        options={rolesList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        components={{ Option }}
                        onChange={handleChangeRoleAccess}
                        value={optionSelected}
                      />
                    </div>
                  </div>
                  <div className="checkbox">
                    <p>Access</p>
                    {screenRoles?.map((obj: any, i: number) => (
                      <Form.Check
                        disabled={Object.keys(optionSelected).length === 0}
                        onChange={(e) =>
                          handleChaneRoleAccessPage(e, obj.screen.toUpperCase())
                        }
                        checked={roleAccessPage.find(
                          (page: string) => page === obj.screen.toUpperCase()
                        )}
                        name={obj.screen}
                        type="checkbox"
                        id={`screen${i}`}
                        label={obj.screen}
                      />
                    ))}
                  </div>
                </div>
                <div className={"craditials craditials-box"}>
                  <Button
                    disabled={
                      Object.keys(optionSelected).length === 0 ||
                      rolesList
                        .find((x) => x._id === optionSelected._id)
                        ?.access_screen?.toString() ===
                      roleAccessPage.toString()
                    }
                    variant="dark"
                    onClick={() => handleSaveRoleAccess()}
                  >
                    Save
                  </Button>
                </div>
              </>
    )
}
export default RolesTab;